module.exports = __webpack_public_path__ + "img/RS.6e843b9e.svg";